import { render, staticRenderFns } from "./address-item.vue?vue&type=template&id=d7d5bba4&"
import script from "./address-item.vue?vue&type=script&lang=js&"
export * from "./address-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/sites/www/new.crt.ru/html/current_version/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d7d5bba4')) {
      api.createRecord('d7d5bba4', component.options)
    } else {
      api.reload('d7d5bba4', component.options)
    }
    module.hot.accept("./address-item.vue?vue&type=template&id=d7d5bba4&", function () {
      api.rerender('d7d5bba4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/components/address-item/address-item.vue"
export default component.exports